var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      directives: [
        { name: "model", rawName: "v-model", value: _vm.val, expression: "val" }
      ],
      staticClass: "form-control",
      attrs: {
        id: _vm.id,
        lang: "en",
        disabled: _vm.disabled,
        type: "number",
        step: _vm.step,
        min: _vm.min
      },
      domProps: { value: _vm.val },
      on: {
        keypress: _vm.isNumber,
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.val = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _vm.errorText
      ? _c("span", { staticClass: "help-block" }, [
          _c("p", { staticStyle: { color: "darkred" } }, [
            _vm._v(_vm._s(_vm.errorText))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86b04e34", { render: render, staticRenderFns: staticRenderFns })
  }
}